import React, { useState, useEffect } from "react";
import UserProfileInput from "./UserProfileInput";
import { Col, Row, Spinner } from "reactstrap";
import UserProfilePhone from "./UserProfilePhone";
import { useSelector, useDispatch } from "react-redux";
import { updateProfile } from "../../redux/thunks/userThunks";
import { initializeUserFromStorage } from "../../redux/slices/userSlice";
import UserProfileCountry from "./UserProfileCountry";
import { useTranslation } from "react-i18next";
import UserProfileDate from "./UserProfileDate";

const parseAddress = (addressStr = "") => {
  const [
    line1 = "",
    line2 = "",
    city = "",
    province = "",
    postalCode = "",
    country = "",
  ] = typeof addressStr === "string" ? addressStr.split(",") : [];

  return {
    line1,
    line2,
    city,
    province,
    postalCode,
    country,
  };
};

const UserProfileGeneral = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeUserFromStorage());
  }, []);

  const userInfo = useSelector((state) => state.user.user.data);

  const [formData, setFormData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    username: "",
    area_code: "",
    phone_number: "",
    email: "",
    address1: "",
    address2: "",
    city: "",
    province: "",
    postal_code: "",
    country: "",
    date_of_birth: "",
  });

  useEffect(() => {
    if (userInfo) {
      const addressFields = parseAddress(userInfo.address ?? "");
      setFormData({
        first_name: userInfo.first_name || "",
        middle_name: userInfo.middle_name || "",
        last_name: userInfo.last_name || "",
        username: userInfo.username || "",
        area_code: userInfo.area_code || "",
        phone_number: userInfo.phone_number || "",
        email: userInfo.email || "",
        address1: addressFields.line1 || "",
        address2: addressFields.line2 || "",
        city: addressFields.city || "",
        province: addressFields.province || "",
        postal_code: addressFields.postalCode || "",
        country: addressFields.country || "",
        date_of_birth: userInfo.date_of_birth || "",
      });
    }
  }, [userInfo]);

  if (!userInfo) {
    return <Spinner />;
  }

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
    console.log("formData", formData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...userInfo,
      ...formData,
      address: `${formData.address1},${formData.address2},${formData.city},${formData.province},${formData.postal_code},${formData.country}`,
    };

    try {
      await dispatch(updateProfile(userInfo.id, payload));
      dispatch(initializeUserFromStorage());
      alert("Profile updated successfully!");
    } catch (err) {
      alert("Failed to update profile.");
    }
  };

  return (
    <div className="col-xl-10">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">{t("personal.info.label")}</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} className="personal_validate">
            <div className="form-row">
              <Row className="align-items-center">
                <Col xs={6}>
                  <UserProfileInput
                    fieldLabel={t("first.name.label")}
                    value={formData.first_name}
                    onChange={handleChange("first_name")}
                  />
                </Col>
                <Col xs={6}>
                  {/* <UserProfileInput
                    fieldLabel={t("middle.name.label")}
                    value={formData.middle_name}
                    onChange={handleChange("middle_name")}
                  /> */}
                  <UserProfileInput
                    fieldLabel={t("last.name.label")}
                    value={formData.last_name}
                    onChange={handleChange("last_name")}
                  />
                </Col>
              </Row>

              <Row className="align-items-center">
                <Col xs={6}>
                  <UserProfileDate
                    fieldLabel="Date of Birth"
                    name="date_of_birth"
                    value={formData.date_of_birth}
                    onChange={handleChange("date_of_birth")}
                    dateMode
                  />
                </Col>
                <Col xs={6}>
                  <UserProfileInput
                    fieldLabel={t("username.label")}
                    value={formData.username}
                    onChange={handleChange("username")}
                  />
                </Col>
              </Row>

              <Row className="align-items-center">
                <Col xs={6}>
                  <UserProfilePhone
                    fieldLabel={t("phone.number.label")}
                    valueArea={formData.area_code}
                    valuePhone={formData.phone_number}
                    placeholderArea="+1"
                    placeholderPhone={t("phone.number.label")}
                    onChangeArea={(e) =>
                      setFormData({ ...formData, area_code: e.target.value })
                    }
                    onChangePhone={(e) =>
                      setFormData({
                        ...formData,
                        phone_number: e.target.value,
                      })
                    }
                  />
                </Col>
                <Col xs={6}>
                  <UserProfileInput
                    fieldLabel={t("email.label")}
                    value={formData.email}
                    onChange={handleChange("email")}
                  />
                </Col>
              </Row>

              <UserProfileInput
                fieldLabel={t("address.line1.label")}
                value={formData.address1}
                onChange={handleChange("address1")}
              />
              <UserProfileInput
                fieldLabel={t("address.line2.label")}
                value={formData.address2}
                onChange={handleChange("address2")}
              />

              <Row className="align-items-center">
                <Col xs={6}>
                  <UserProfileInput
                    fieldLabel={t("city.label")}
                    value={formData.city}
                    onChange={handleChange("city")}
                  />
                </Col>
                <Col xs={6}>
                  <UserProfileInput
                    fieldLabel={t("state.label")}
                    value={formData.province}
                    onChange={handleChange("province")}
                  />
                </Col>
              </Row>

              <Row className="align-items-center">
                <Col xs={6}>
                  <UserProfileInput
                    fieldLabel={t("zip.code.label")}
                    value={formData.postal_code}
                    onChange={handleChange("postal_code")}
                  />
                </Col>
                <Col xs={6}>
                  <UserProfileCountry
                    fieldLabel={t("country.label")}
                    value={formData.country}
                    onChange={handleChange("country")}
                  />
                </Col>
              </Row>

              <div className="form-group col-12">
                <button type="submit" className="btn btn-success ps-5 pe-5">
                  {t("save.label")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserProfileGeneral;
